import { render, staticRenderFns } from "./FunFactOne.vue?vue&type=template&id=2c9e00d2"
import script from "./FunFactOne.vue?vue&type=script&lang=js"
export * from "./FunFactOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports